import { ParentAndChildDataCheckStatusEnum } from "..";
import { CanCreateRequestStatusEnum } from "./CanCreateRequestStatusEnum";

export interface CreateRequest {
  applicantParentOib: string;
  applicantParentFirstName: string;
  applicantParentLastName: string;
  applicantParentIntegrationResultStatus: ParentAndChildDataCheckStatusEnum;
  childOib: string;
  childFirstName: string;
  childLastName: string;
  childIntegrationResultStatus: ParentAndChildDataCheckStatusEnum;
  canCreateRequestStatus: CanCreateRequestStatusEnum;
  isPublicLogInComfirmd: boolean;
}

export const CreateRequestInitial: CreateRequest = {
  applicantParentOib: "",
  applicantParentFirstName: "",
  applicantParentLastName: "",
  applicantParentIntegrationResultStatus: 0,
  childOib: "",
  childFirstName: "",
  childLastName: "",
  childIntegrationResultStatus: 0,
  canCreateRequestStatus: 0,
  isPublicLogInComfirmd: false,
};